// @flow
import React from 'react';
import type { Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { DSToken } from '@rover/react-lib/styles';

const Spinner: StyledComponent<{}> = styled.i`
  font-size: 14px;
  position: relative;
  color: ${DSToken.TEXT_COLOR_TERTIARY};

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
  animation: spin 2s infinite linear;
`;

export type Props = {
  className: string,
};

const LoadingSpinner = ({ className, ...other }: Props): Node => (
  <Spinner {...other} className={`rover-icon rover-icon-in-spinner ${className}`} />
);

LoadingSpinner.defaultProps = {
  className: '',
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ../react-lib/src/components/typography/LoadingSpinner/LoadingSpinner.jsx